module.exports = __webpack_public_path__ + "static/media/icon.4698876d.png";